var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNxClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-12799 10482 32.018 31.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-12767.769 10482.786a2.689 2.689 0 0 0-3.8 0l-11.47 11.46-11.3-11.3a2.67 2.67 0 1 0-3.773 3.768l11.303 11.282-11.38 11.41a2.69 2.69 0 0 0 3.8 3.8l11.41-11.38 11.3 11.31a2.673 2.673 0 1 0 3.78-3.78l-11.33-11.3 11.46-11.47a2.689 2.689 0 0 0 0-3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxClose);
export default __webpack_public_path__ + "static/media/nx-close.eec7aba620b28e1baac633e5f08db6e8.svg";
export { ForwardRef as ReactComponent };